import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets.app/images/celebrate.svg'


const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = {
  key: 0,
  class: "notification__play-icon"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "notification__play-icon"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

import { BillingView } from '@/models/billing'

import NotificationBox from '@/components/ui/NotificationBox.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'BillingNotifications',
  props: {
    billing: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (__props.billing.showPricesAfterDiscount)
      ? (_openBlock(), _createBlock(NotificationBox, {
          key: 0,
          hideCloseButton: ""
        }, {
          icon: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "notification__play-icon" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ], -1)
          ]))]),
          title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Your discount has been applied!", -1)
          ]))]),
          text: _withCtx(() => [
            _createElementVNode("p", null, _toDisplayString(__props.billing.cancelDiscountAlertText), 1)
          ]),
          link: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createElementVNode("i", null, null, -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.statusMessage)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 1 }, {
          title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
            _createTextVNode(" Billing Status ", -1)
          ]))]),
          text: _withCtx(() => [
            _createElementVNode("p", {
              innerHTML: __props.billing.statusMessage
            }, null, 8, _hoisted_1)
          ]),
          link: _withCtx(() => [...(_cache[4] || (_cache[4] = [
            _createElementVNode("i", null, null, -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.afterCancelTrialAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 2 }, {
          icon: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createElementVNode("i", null, null, -1)
          ]))]),
          title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
            _createTextVNode(" You Have Successfully Canceled ", -1)
          ]))]),
          text: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createElementVNode("p", null, " You have successfully canceled your subscription during the free trial and you will not be charged. You can re-subscribe at any time—we'd love to have you back! ", -1),
            _createElementVNode("p", null, " In the meantime, we'll keep working hard to make Shortform better. ", -1)
          ]))]),
          link: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createElementVNode("i", null, null, -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.afterCancelPaidAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 3 }, {
          icon: _withCtx(() => [...(_cache[9] || (_cache[9] = [
            _createElementVNode("i", null, null, -1)
          ]))]),
          title: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" You Have Successfully Canceled ", -1)
          ]))]),
          text: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createElementVNode("p", null, " You've canceled your subscription and you will not be charged again in the future. You can re-subscribe at any time—we'd love to have you back! ", -1),
            _createElementVNode("p", null, " In the meantime, we'll keep working hard to make Shortform better. ", -1)
          ]))]),
          link: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createElementVNode("i", null, null, -1)
          ]))]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.subscribedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 4 }, {
          icon: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[13] || (_cache[13] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("span", _hoisted_3))
          ]),
          title: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " You've successfully changed to the annual plan! "))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, " You've successfully changed to the monthly plan. "))
          ]),
          text: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, " You now save " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "% on your Shortform subscription. Wise choice! ", 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_7, " Change back to the annual plan anytime to save " + _toDisplayString(__props.billing.switchToAnnualSavings.percent) + "% off the subscription price. ", 1))
          ]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode("Open Books", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.resubscribedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 5 }, {
          icon: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9))
          ]),
          title: _withCtx(() => [
            (__props.billing.plan.id === 'plan_annual')
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, " You've successfully resubscribed to the annual plan! "))
              : (_openBlock(), _createElementBlock("span", _hoisted_11, " You've successfully resubscribed to the monthly plan! "))
          ]),
          text: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createElementVNode("span", null, null, -1)
          ]))]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                _createTextVNode("Open Books", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.downgradedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 6 }, {
          icon: _withCtx(() => [...(_cache[18] || (_cache[18] = [
            _createElementVNode("span", null, null, -1)
          ]))]),
          title: _withCtx(() => [
            _createElementVNode("span", null, " You've successfully downgraded to the Monthly plan! Your Annual plan will continue until " + _toDisplayString(__props.billing.billingPeriodEnd) + " and then will switch to Monthly. ", 1)
          ]),
          text: _withCtx(() => [...(_cache[19] || (_cache[19] = [
            _createElementVNode("span", null, null, -1)
          ]))]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createTextVNode("Open Books", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.upgradedAlert)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 7 }, {
          icon: _withCtx(() => [...(_cache[21] || (_cache[21] = [
            _createElementVNode("span", null, null, -1)
          ]))]),
          title: _withCtx(() => [
            _createElementVNode("span", null, " You've successfully upgraded to the Annual plan! Your Monthly plan will continue until " + _toDisplayString(__props.billing.billingPeriodEnd) + " and then will switch to Annual. ", 1)
          ]),
          text: _withCtx(() => [...(_cache[22] || (_cache[22] = [
            _createElementVNode("span", null, null, -1)
          ]))]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns"
            }, {
              default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                _createTextVNode("Open Books", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.billing.subscribedAlertAndRedirect)
      ? (_openBlock(), _createBlock(NotificationBox, { key: 8 }, {
          icon: _withCtx(() => [...(_cache[24] || (_cache[24] = [
            _createElementVNode("div", { class: "notification__play-icon" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ], -1)
          ]))]),
          title: _withCtx(() => [...(_cache[25] || (_cache[25] = [
            _createTextVNode(" Welcome to Shortform! ", -1)
          ]))]),
          text: _withCtx(() => [...(_cache[26] || (_cache[26] = [
            _createElementVNode("p", null, " You now have full access to Shortform. We'll redirect you to books shortly... ", -1)
          ]))]),
          link: _withCtx(() => [
            _createVNode(_component_router_link, {
              to: { name: 'books' },
              class: "btns btns--large"
            }, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                _createTextVNode("Open Books", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})